module.exports = __webpack_public_path__ + "img/layers.de948dee.png";